import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Iframe from 'react-iframe'

// @material-ui/icons
import Chat from "@material-ui/icons/Chat";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import Fingerprint from "@material-ui/icons/Fingerprint";
import { FaCannabis } from 'react-icons/fa';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

import { ImLocation2 } from "react-icons/im";
import { RiContactsFill } from "react-icons/ri";
import { FaRegClock } from "react-icons/fa";

class CowieRoadShop extends React.Component {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.section}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={8}>
                        <h2 className={classes.title}>Cowie Road</h2>
                    </GridItem>
                </GridContainer>
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={4}>
                            <InfoArea
                                title="Location"
                                description="147 Cowey Road,
                                Morningside,
                                Berea, 4001"
                                icon={ImLocation2}
                                iconColor="success"
                                vertical
                            />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={4}>
                            <InfoArea
                                title="Trading Hours"
                                description="Every Day : 10:00 –  17:00 "
                                icon={FaRegClock}
                                iconColor="info"
                                vertical
                            />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={4}>
                            <InfoArea
                                title="Contact"
                                description="Telephone : +27 (61) 886 0055        
         
                                E-mail : rooftop420durban@gmail.com"
                                icon={RiContactsFill}
                                iconColor="success"
                                vertical
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer>

                        <GridItem xs={12} sm={12} md={3}>

                        </GridItem>
                        <GridItem xs={12} sm={12} md={6} >
                            <div style={{ height: "20rem" }}>
                                <Iframe url="https://www.google.com/maps/embed/v1/place?key=AIzaSyC1AUc4pCRVhdXfJeauIgj1H3N89Xy2qxo
                            &q=place_id:ChIJ4V-yofUH9x4Rf7YqhrYPsOA"
                                    width="100%"
                                    height="100%"
                                    id="myId"
                                    className="myClassname"
                                    display="initial"
                                    position="relative" />
                            </div>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={3}>

                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        );
    }
}

export default withStyles(productStyle)(CowieRoadShop);
